<template>
  <div class="activity-list">
    <el-row :gutter="20" class="operate-bar">
      <el-col :span="4" align="left">
        <!-- 新增场次按钮 -->
        <el-button icon="el-icon-plus" type="primary" @click="openAddDialog"
          v-hasPermission="'activity:edit'">新增场次</el-button>
        <!-- 批量删除按钮（选中场次后可用） -->
        <el-button icon="el-icon-delete" type="danger" v-hasPermission="'activity:edit'" @click="handleBatchDelete"
          :disabled="!this.hasPermission('activity:edit') || selectedIds.length === 0">批量删除</el-button>
      </el-col>
      <!-- 搜索区域 -->
      <el-col :span="20" align="right">
        <el-form :inline="true" :model="searchForm" class="search-form">
          <el-form-item label="场次名称">
            <el-input v-model="searchForm.activityName" placeholder="请输入场次名称" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
              <el-option :value="0" label="进行中"></el-option>
              <el-option :value="1" label="未开始"></el-option>
              <el-option :value="2" label="已结束"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场次开始日期区间">
            <el-date-picker
              v-model="searchForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-button icon="el-icon-search" type="primary" @click="loadActivities">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form>
      </el-col>
    </el-row>

    <!-- 数据表格 -->
    <el-table :data="activities" border stripe style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center"></el-table-column>
      <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
      <el-table-column prop="activityName" label="场次名称" header-align="center">
        <template slot-scope="scope">
          <el-link type="primary"  @click="$router.push({ name: 'ShootingScoreList', query: { activityId: scope.row.id } })">
            {{ scope.row.activityName }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="orgName" label="组织机构名称" header-align="center"></el-table-column>
      <el-table-column prop="startTime" label="场次开始时间"
        :formatter="(row, column, cellValue) => $options.filters.formatTime(cellValue)"
        align="center"></el-table-column>
      <el-table-column prop="endTime" label="场次结束时间"
        :formatter="(row, column, cellValue) => $options.filters.formatTime(cellValue)"
        align="center"></el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 0 ? 'success' : scope.row.status === 1 ? 'warning' : 'danger'">
            {{ scope.row.status === 0 ? '进行中' : scope.row.status === 1 ? '未开始' : '已结束' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="已分配设备" align="center">
        <template slot-scope="scope">
          {{ (scope.row.targets || []).map(target => `${target.warZone}-${target.targetNo}`).join(', ') || '未分配' }}
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" header-align="center"></el-table-column>
      <el-table-column prop="createTime" label="创建时间"
        :formatter="(row, column, cellValue) => $options.filters.formatTime(cellValue)"
        align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="400">
        <template slot-scope="scope">
          <el-tooltip content="编辑" placement="top">
            <el-button icon="el-icon-edit" type="primary" circle v-hasPermission="'activity:edit'"
              @click="openEditDialog(scope.row)" :disabled="scope.row.status !== 1"></el-button>
          </el-tooltip>
          <el-tooltip content="开始场次" placement="top">
            <el-button icon="el-icon-video-play" type="success" circle v-hasPermission="'activity:edit'"
              @click="handleStart(scope.row.id)" :disabled="scope.row.status !== 1"></el-button>
          </el-tooltip>
          <el-tooltip content="结束场次" placement="top">
            <el-button icon="el-icon-switch-button" type="danger" circle v-hasPermission="'activity:edit'"
              @click="handleEnd(scope.row.id)" :disabled="scope.row.status !== 0"></el-button>
          </el-tooltip>
          <el-tooltip content="查看场次内人员" placement="top">
            <el-button icon="el-icon-user" type="warning" circle v-hasPermission="'activity:edit'"
              @click="$router.push({ name: 'ShooterList', query: { activityId: scope.row.id } })"
              :disabled="scope.row.status == 2"></el-button>
          </el-tooltip>
          <el-tooltip content="分配设备" placement="top">
            <el-button icon="el-icon-aim" type="success" circle v-hasPermission="'activity:edit'"
              @click="openAssignTargetDialog(scope.row)" :disabled="scope.row.status == 2"></el-button>
          </el-tooltip>
          <el-tooltip content="删除" placement="top">
            <el-button icon="el-icon-delete" type="danger" circle v-hasPermission="'activity:edit'"
              @click="handleDelete(scope.row.id)" :disabled="scope.row.status == 0"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
      :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="total"></el-pagination>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="组织机构" prop="orgId">
          <el-select v-model="form.orgId" filterable placeholder="请选择组织机构" clearable style="width: 100%">
            <el-option v-for="org in userOrgs" :key="org.id" :label="org.orgName" :value="org.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="场次名称" prop="activityName">
          <el-input v-model="form.activityName" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="form.remark" rows="3" maxlength="200"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false; $refs.form.resetFields()">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 分配设备对话框 -->
    <el-dialog title="分配设备" :visible.sync="assignTargetVisible" width="1000px">
      <el-transfer :data="targets" :titles="['可选设备', '已选设备']"
        :props="{ key: 'id'}" v-model="selectedTargetIds">
        <span slot-scope="{ option }">{{ option.warZone }} - {{ option.targetNo }} ({{ option.imei }})</span>
      </el-transfer>
      <div slot="footer">
        <el-button @click="assignTargetVisible = false; targets = []">取消</el-button>
        <el-button type="primary" @click="saveTargets">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import store from '../../store';
import activityApi from '../../api/activity'
import targetApi from '../../api/target'
import { hasPermission } from '../../utils/hasPermission'

export default {
  name: 'ShootingActivityList',
  data() {
    return {
      // 表格数据
      activities: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,

      // 搜索表单
      searchForm: {
        activityName: '',
        status: '',
        dateRange: []
      },

      // 选中的行
      selectedIds: [],

      // 对话框
      dialogVisible: false,
      dialogTitle: '新增场次',
      isEdit: false,
      recordId: null, // 编辑时记录当前账号的ID，用于排除自身
      form: {
        id: null,
        orgId: '',
        activityName: '',
        remark: '',
        status: 1
      },
      rules: {
        orgId: [
          { required: true, message: '请选择组织机构', trigger: 'change' }
        ],
        activityName: [
          { required: true, message: '请输入场次名称', trigger: 'blur' },
          { min: 2, max: 20, message: '场次名称长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        remark: [
          { min: 1, max: 200, message: '备注长度在 1 到 200 个字符', trigger: 'blur' }
        ]
      },

      selectedActivityId: null,
      // 分配设备
      targets: [], // 可选设备列表
      assignTargetVisible: false,
      selectedTargetIds: [],// el-transfer绑定的已选设备ID
      hasAssignedTarget: false, // 是否已分配设备

      userOrgs: store.state.user.userInfo.orgs,
    }
  },

  created() {
    this.loadActivities()
  },

  methods: {
    // 加载场次列表
    loadActivities() {
      // 组装请求参数
      const params = {
        userOrgIds: this.userOrgs.map(org => org.id), // 用户所负责的组织机构ID列表
        activityName: this.searchForm.activityName, // 搜索-场次名称
        status: this.searchForm.status,             // 搜索-状态
        startTime: this.searchForm.dateRange?.[0],  // 搜索-日期范围
        endTime: this.searchForm.dateRange?.[1],    // 搜索-日期范围
        page: this.currentPage,                     // 分页-当前页
        size: this.pageSize                         // 分页-每页条数
      };
      activityApi.findAll(params).then(response => {
        if (response.success) {
          this.activities = response.data.data
          this.total = response.data.total
        } else {
          this.$message.error(response.message)
        }
      }).catch(error => {
        this.$message.error('加载场次失败：' + error.message)
      })
    },

    // 加载所有未分配设备
    loadTargets() {
      const params = {
        userOrgIds: this.userOrgs.map(org => org.id), // 用户所负责的组织机构ID列表
        activityId: this.selectedActivityId,
        hasAssignedTarget: this.hasAssignedTarget
      };
      targetApi.findForAssignTarget(params).then(response => {
        if (response.success) {
          this.targets = response.data
        } else {
          this.$message.error(response.message)
        }
      }).catch(error => {
        this.$message.error('加载设备失败：' + error.message)
      })
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        activityName: '',
        status: '',
        dateRange: []
      }
      this.loadActivities()
    },

    // 每页条数变化时
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadActivities(); // 重新加载
    },

    // 当前页变化时
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadActivities(); // 重新加载
    },

    // 选择变化
    handleSelectionChange(selection) {
      this.selectedIds = selection.map(item => item.id)
    },

    // 打开新增对话框
    openAddDialog() {
      if (!hasPermission('activity:edit')) {
        this.$message.error('无新增权限');
        return;
      }
      this.dialogTitle = '新增场次'
      this.isEdit = false
      this.recordId = null
      this.form = {
        id: null,
        orgId: '',
        activityName: '',
        remark: '',
        status: 1
      }
      this.dialogVisible = true
    },

    // 打开编辑对话框
    openEditDialog(row) {
      if (!hasPermission('activity:edit')) {
        this.$message.error('无编辑权限');
        return;
      }
      this.dialogTitle = '编辑场次'
      this.isEdit = true
      this.recordId = row.id
      this.form = { ...row }
      this.dialogVisible = true
    },

    // 提交表单
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.isEdit) {
            // 更新场次
            activityApi.update(this.form.id, this.form).then(response => {
              if (response.success) {
                this.$message.success(response.message || '更新成功')
                this.dialogVisible = false
                this.loadActivities()
              } else {
                this.$message.error(response.message)
              }
            }).catch(error => {
              this.$message.error('更新失败：' + error.message)
            })
          } else {
            // 新增场次
            activityApi.add(this.form).then(response => {
              if (response.success) {
                this.$message.success(response.message || '新增成功')
                this.dialogVisible = false
                this.loadActivities()
              } else {
                this.$message.error(response.message)
              }
            }).catch(error => {
              this.$message.error('新增失败：' + error.message)
            })
          }
        }
      })
    },

    // 删除场次
    handleDelete(id) {
      if (!hasPermission('activity:edit')) {
        this.$message.error('无删除权限');
        return;
      }
      this.$confirm('确定要删除该场次吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        activityApi.delete(id).then(response => {
          if (response.success) {
            this.$message.success(response.message || '删除成功')
            this.loadActivities()
          } else {
            this.$message.error(response.message)
          }
        }).catch(error => {
          this.$message.error('删除失败：' + error.message)
        })
      }).catch(() => {
        // 取消操作（此处可留空，仅用于捕获异常）
      });
    },

    // 批量删除场次
    handleBatchDelete() {
      if (!hasPermission('activity:edit')) {
        this.$message.error('无删除权限');
        return;
      }
      if (this.selectedIds.length === 0) {
        this.$message.warning('请选择要删除的场次');
        return;
      }
      this.$confirm('确定要批量删除选中的场次吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        activityApi.deleteBatch(this.selectedIds).then(response => {
          if (response.success) {
            this.$message.success(response.message || '批量删除成功')
            this.loadActivities()
            this.selectedIds = []
          } else {
            this.$message.error(response.message)
          }
        }).catch(error => {
          this.$message.error('批量删除失败：' + error.message)
        })
      }).catch(() => {
        // 取消操作（此处可留空，仅用于捕获异常）
      });
    },

    // 打开分配设备对话框
    openAssignTargetDialog(row) {
      if (!hasPermission('activity:edit')) {
        this.$message.error('无分配设备权限');
        return;
      }
      this.selectedActivityId = row.id
      this.assignTargetVisible = true
      // 获取已选设备ID
      this.selectedTargetIds = (row.targets || []).map(target => target.id)
      this.hasAssignedTarget = (row.targets || []).length > 0
      this.loadTargets();
    },

    // 保存设备分配
    saveTargets() {
      activityApi.assignTargets(this.selectedActivityId, this.selectedTargetIds).then(response => {
        if (response.success) {
          this.$message.success(response.message || '设备分配成功')
          this.assignTargetVisible = false
          this.loadActivities()
          this.targets = []
        } else {
          this.$message.error(response.message)
        }
      }).catch(error => {
        this.$message.error('设备分配失败：' + error.message)
      })
    },

    hasPermission(permCode) {
      return hasPermission(permCode);
    },

    // 开始场次
    handleStart(id) {
      if (!hasPermission('activity:edit')) {
        this.$message.error('无开始权限');
        return;
      }
      this.$confirm('确定要开始该场次吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        activityApi.updateStatus(id, 0).then(response => {
          if (response.success) {
            this.$message.success(response.message || '开始成功')
            // 跳转到该场次分配的设备的缩略成绩页
            this.$router.push({ name: 'ShootingScoreList', query: { activityId: id } })
          } else {
            this.$message.error(response.message)
          }
        }).catch(error => {
          this.$message.error('开始失败：' + error.message)
        })
      }).catch(() => {
        // 取消操作（此处可留空，仅用于捕获异常）
      });
    },

    // 结束场次
    handleEnd(id) {
      if (!hasPermission('activity:edit')) {
        this.$message.error('无结束权限');
        return;
      }
      this.$confirm('确定要结束该场次吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        activityApi.updateStatus(id, 2).then(response => {
          if (response.success) {
            this.$message.success(response.message || '结束成功')
            this.loadActivities()
          } else {
            this.$message.error(response.message)
          }
        }).catch(error => {
          this.$message.error('结束失败：' + error.message)
        })
      }).catch(() => {
        // 取消操作（此处可留空，仅用于捕获异常）
      });
    },
  }
}
</script>

<style scoped>
/* 强制左右列等宽，调整整体布局 */
::v-deep .el-dialog .el-transfer {
  /* 确保组件宽度与设置的width一致，避免留白 */
  width: 100% !important;
}

/* 强制左右列表格宽度相等（各占40%） */
::v-deep .el-dialog .el-transfer-panel {
  width: 40% !important;
  /* 修复右侧留白：去掉默认的margin-right */
  margin-right: 0 !important;
}

/* 穿透作用域，强制 el-transfer 整体左对齐 */
::v-deep .el-dialog .el-transfer {
  text-align: left !important;
  /* 覆盖全局的 center */
}

/* 确保左右面板内的内容也左对齐 */
::v-deep .el-dialog.el-transfer-panel {
  text-align: left !important;
}

/* 修复选项项（复选框+文字）的对齐 */
::v-deep .el-dialog.el-transfer-panel__item {
  display: flex;
  align-items: center;
  /* 复选框与文字垂直居中 */
}
</style>